var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPpt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 666.667,
    height: 666.667,
    fillRule: "evenodd",
    clipRule: "evenodd",
    imageRendering: "optimizeQuality",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    viewBox: "0 0 17639 17639",
    id: "powerpoint",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#d04525",
    d: "m3457 4868 6169-1132v10167l-6171-916 2-8119zm6421 2152 5-636 3452 1v5539H9878l2-565h2397v-493H9878v-424h2399v-458H9878v-460c1526 249 1821-792 1799-1269h-1341V6950c-158 19-334 30-458 70zm0-1307 4235 2-2 5045h-388V6068H9878v-355zm-7797 9880h13478l-2-13476H2081v13476z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#d04525",
    d: "M6303 7731c490-47 729 32 706 552-20 445-268 528-713 503l7-1055zm-593-592-13 3427 579 37 18-1189c481-45 852-53 1100-326 228-251 341-698 287-1145-134-1091-1003-822-1971-804zm4838 904h1305c0-740-388-1270-1303-1270l-2 1270z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M6296 8786c445 25 693-58 713-503 23-520-216-599-706-552l-7 1055z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPpt);
export default __webpack_public_path__ + "static/media/PPT.ae0e7d1bf782aa8f2bb392136cb6d5bb.svg";
export { ForwardRef as ReactComponent };